import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AccessibilityBypassBlock } from '@skillz/accessibility';
import ScrollLTR from "../../../shared/components/ui/scrollLTR/ScrollLTR";
import { isMenuRoute } from "../../constants/menuTabs";
import LandscapeMessage from "./landscapeMessage/LandscapeMessage";
import MenuMobile from "./menuMobile/MenuMobile";
import classes from './LayoutMobile.module.css';

const LayoutMobile = ({ dynamicTabs = [] }) => {

    const { texts } = useSelector(state => state.translate);
    const scrollerRef = useRef(null);
    const location = useLocation();
    const [showMenu, setShowMenu] = useState(false);
    const isIframeRoute = dynamicTabs?.some(tab => (tab.type === "iframe" || tab.type === "iframeJwt") && location.pathname.includes(tab.route));

    useEffect(() => {
        setShowMenu(isMenuRoute(location.pathname, dynamicTabs));
    }, [location.pathname, dynamicTabs]);

    return (
        <div className={classes.Layout}>
            <AccessibilityBypassBlock id="main" text={texts.skipToMainContent} />
            <LandscapeMessage />
            <div className={classes.MobileShell}>
                <main className={`${classes.Main} ${showMenu ? classes.WithMenu : classes.NoMenu}`}>
                    <ScrollLTR ref={scrollerRef} dropClass={`${classes.Outlet} ${isIframeRoute ? classes.OutletIframe : ''}`} height="100%">
                        <div className={isIframeRoute ? classes.ContentIframe : classes.Content}>
                            <Outlet />
                        </div>
                    </ScrollLTR>
                </main>
                {showMenu && <MenuMobile dynamicTabs={dynamicTabs} />}
            </div>
        </div>
    )
}
export default LayoutMobile;